import {disclaimerObject} from "../disclaimerObject";

export class disclaimerObject_fr_BE extends disclaimerObject{
    // eslint-disable-next-line
    constructor() {
        super();
    }

    getDisclaimer = (params) => {
        const {
            financialProduct
        } = params;

        return financialProduct?.disclaimer_fr_BE;
    }

}

export default disclaimerObject_fr_BE;